export default {
  GET_PRODUCTS: `#graphql
  query getInventoryProducts($brand: String!) {
    getInventoryProducts(brand: $brand) {
      tier
      items {
        product
        size
        quantity
        brand
        folder
        subfolder
        image
      }
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/inventory.js